import confirmation from '@front/common/components/ConfirmationModal/ConfirmationModal.store'
import cart from '@front/common/store/cart'
import modal from '@front/common/store/modal'
import alert from '@front/ui/Alert/Alert.store'
import Vuex from 'vuex'

import customer from '@member-area/core/resources/Customer/Customer.store'
import discount from '@member-area/core/resources/Discount/Discount.store'
import nextDelivery from '@member-area/core/resources/NextDelivery/NextDelivery.store'
import nextOrder from '@member-area/core/resources/NextOrder/NextOrder.store'
import order from '@member-area/core/resources/Order/Order.store'
import paymentMethod from '@member-area/core/resources/PaymentMethod/PaymentMethod.store'
import pet from '@member-area/core/resources/Pet/Pet.store'
import product from '@member-area/core/resources/Product/Product.store'
import recipe from '@member-area/core/resources/Recipe/Recipe.store'
import subscription from '@member-area/core/resources/Subscription/Subscription.store'
import transaction from '@member-area/core/resources/Transaction/Transaction.store'
import upsellHighlight from '@member-area/core/resources/UpsellHighlight/UpsellHighlight.store'
import auth from '@member-area/middleware/auth.store'

const createStore = () => {
  return new Vuex.Store({
    modules: {
      upsellHighlight,
      subscription,
      paymentMethod,
      cart,
      transaction,
      nextDelivery,
      discount,
      customer,
      product,
      modal,
      recipe,
      order,
      alert,
      pet,
      auth,
      nextOrder,
      confirmation,
    },
  })
}

export default createStore
